import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    vessel_id: null,
    audit_id: null,
    inspection_id: null,
    category_id: null,
    section_id: null,
    question_id: null,
};

const inspectionSlice = createSlice({
    name: 'inspection',
    initialState,
    reducers: {
        setVesselId: (state, action) => {
            state.vessel_id = action.payload
        },
        setAuditId: (state, action) => {
            state.audit_id = action.payload
        },
        setInspectionId: (state, action) => {
            state.inspection_id = action.payload
        },
        setCategoryId: (state, action) => {
            state.category_id = action.payload
        },
        setSectionId: (state, action) => {
            state.section_id = action.payload
        },
        setQuestionId: (state, action) => {
            state.question_id = action.payload
        },
    },
});

export const { setVesselId, setAuditId, setInspectionId, setCategoryId, setSectionId, setQuestionId } = inspectionSlice.actions;
export default inspectionSlice.reducer;